import servicesUtils from "../../../utils/servicesUtils";
var getNotificationsCenter = function getNotificationsCenter() {
  return servicesUtils.getService("/notifications/center/");
};
export default getNotificationsCenter;